import { render } from "./ObjectDetail.vue?vue&type=template&id=684348f2&scoped=true"
import script from "./ObjectDetail.vue?vue&type=script&lang=js"
export * from "./ObjectDetail.vue?vue&type=script&lang=js"

import "./ObjectDetail.vue?vue&type=style&index=0&id=684348f2&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684348f2"]])

export default __exports__